// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#globalsearch-container {
  position: relative;
}
#globalsearch-container .s-icon-block {
  height: 20px;
  display: flex;
  position: absolute;
  left: 14px;
  top: 14px;
}
#globalsearch-container input {
  height: 47px;
  padding: 0px 0px 0px 40px;
  border: unset;
  width: 400px;
  background-color: #f8f9fb;
  font-size: 16px;
  font-style: "f-400";
}
#globalsearch-container .global-search-menu-list {
  position: absolute;
  left: 0;
  top: 51px;
  background-color: var(--ffff);
  z-index: 999;
  width: 100%;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  border: 1px solid var(--e3e3);
  border-radius: 4px;
  max-height: 375px;
  overflow: auto;
}
#globalsearch-container .global-search-menu-list .global-search-item {
  border-bottom: 1px solid var(--e3e3);
  padding: 10px 20px 10px 20px;
  cursor: pointer;
}
#globalsearch-container .global-search-menu-list .global-search-item:hover {
  background-color: var(--56ff);
}
#globalsearch-container .global-search-menu-list .global-search-item:hover div {
  color: var(--ffff) !important;
}

#globalsearch-container-dark {
  position: relative;
}
#globalsearch-container-dark .s-icon-block {
  height: 20px;
  display: flex;
  position: absolute;
  left: 14px;
  top: 14px;
}
#globalsearch-container-dark input {
  height: 47px;
  padding: 0px 0px 0px 40px;
  border: 1 px solid var(--4d6c);
  width: 400px;
  color: var(--ffff);
  background-color: var(--4d6c);
  font-size: 16px;
  font-style: "f-400";
}
#globalsearch-container-dark input::placeholder {
  color: var(--c9c9);
}
#globalsearch-container-dark .global-search-menu-list {
  position: absolute;
  left: 0;
  top: 51px;
  background-color: var(--2b4e);
  color: var(--ffff);
  z-index: 999;
  width: 100%;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  border: 1px solid var(--4d6c);
  border-radius: 4px;
  max-height: 375px;
  overflow: auto;
}
#globalsearch-container-dark .global-search-menu-list .global-search-item {
  border-bottom: 1px solid var(--e3e3);
  padding: 10px 20px 10px 20px;
  cursor: pointer;
}
#globalsearch-container-dark .global-search-menu-list .global-search-item:hover {
  background-color: var(--4d6c);
}
#globalsearch-container-dark .global-search-menu-list .global-search-item:hover div {
  color: var(--ffff) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/layouts/GlobalSearch/GlobalSearch.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;AAAE;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;AAEJ;AAAE;EACE,YAAA;EACA,yBAAA;EACA,aAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;AAEJ;AAAE;EACE,kBAAA;EACA,OAAA;EACA,SAAA;EACA,6BAAA;EACA,YAAA;EACA,WAAA;EACA,2CAAA;EACA,6BAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;AAEJ;AADI;EACE,oCAAA;EACA,4BAAA;EACA,eAAA;AAGN;AAFM;EACE,6BAAA;AAIR;AAHQ;EACE,6BAAA;AAKV;;AACA;EACE,kBAAA;AAEF;AADE;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;AAGJ;AADE;EACE,YAAA;EACA,yBAAA;EACA,8BAAA;EACA,YAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;EACA,mBAAA;AAGJ;AAFI;EACE,kBAAA;AAIN;AADE;EACE,kBAAA;EACA,OAAA;EACA,SAAA;EACA,6BAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,2CAAA;EACA,6BAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;AAGJ;AAFI;EACE,oCAAA;EACA,4BAAA;EACA,eAAA;AAIN;AAHM;EACE,6BAAA;AAKR;AAJQ;EACE,6BAAA;AAMV","sourcesContent":["#globalsearch-container {\r\n  position: relative;\r\n  .s-icon-block {\r\n    height: 20px;\r\n    display: flex;\r\n    position: absolute;\r\n    left: 14px;\r\n    top: 14px;\r\n  }\r\n  input {\r\n    height: 47px;\r\n    padding: 0px 0px 0px 40px;\r\n    border: unset;\r\n    width: 400px;\r\n    background-color: #f8f9fb;\r\n    font-size: 16px;\r\n    font-style: \"f-400\";\r\n  }\r\n  .global-search-menu-list {\r\n    position: absolute;\r\n    left: 0;\r\n    top: 51px;\r\n    background-color: var(--ffff);\r\n    z-index: 999;\r\n    width: 100%;\r\n    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);\r\n    border: 1px solid var(--e3e3);\r\n    border-radius: 4px;\r\n    max-height: 375px;\r\n    overflow: auto;\r\n    .global-search-item {\r\n      border-bottom: 1px solid var(--e3e3);\r\n      padding: 10px 20px 10px 20px;\r\n      cursor: pointer;\r\n      &:hover {\r\n        background-color: var(--56ff);\r\n        div {\r\n          color: var(--ffff) !important;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n#globalsearch-container-dark {\r\n  position: relative;\r\n  .s-icon-block {\r\n    height: 20px;\r\n    display: flex;\r\n    position: absolute;\r\n    left: 14px;\r\n    top: 14px;\r\n  }\r\n  input {\r\n    height: 47px;\r\n    padding: 0px 0px 0px 40px;\r\n    border: 1 px solid var(--4d6c);\r\n    width: 400px;\r\n    color: var(--ffff);\r\n    background-color: var(--4d6c);\r\n    font-size: 16px;\r\n    font-style: \"f-400\";\r\n    &::placeholder {\r\n      color: var(--c9c9);\r\n    }\r\n  }\r\n  .global-search-menu-list {\r\n    position: absolute;\r\n    left: 0;\r\n    top: 51px;\r\n    background-color: var(--2b4e);\r\n    color: var(--ffff);\r\n    z-index: 999;\r\n    width: 100%;\r\n    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);\r\n    border: 1px solid var(--4d6c);\r\n    border-radius: 4px;\r\n    max-height: 375px;\r\n    overflow: auto;\r\n    .global-search-item {\r\n      border-bottom: 1px solid var(--e3e3);\r\n      padding: 10px 20px 10px 20px;\r\n      cursor: pointer;\r\n      &:hover {\r\n        background-color: var(--4d6c);\r\n        div {\r\n          color: var(--ffff) !important;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
